const i18n = {
  'resetPassword': {
    'form': {
      'password': '新密碼',
      'confirmPassword': '確認密碼',
      'resetPassword': '重設密碼',
      'loading': '驗證中...',
      'loginPage': '登入頁面',
      'invalidToken': '重新取得重設密碼連結',
      'tokenExpired': '重新取得重設密碼連結',
      'success': '請以新密碼重新登入'
    },
    'error': {
      'invalidToken': '無效的 Token',
      'tokenExpired': '重設密碼的連結已失效',
      'emptyPassword': '密碼為必填',
      'confirmPassword': '兩次輸入的密碼不同',
    }
  }
};
export default i18n;
